<app-navbar *ngIf="showNavbar" ngSkipHydration></app-navbar>

<p-toast [life]="5000"></p-toast>

<div class="main-wrapper">
  <router-outlet></router-outlet>
  <app-footer *ngIf="showFooter"></app-footer>
</div>
